/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrencyRateRequestDto
 */
export interface CurrencyRateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CurrencyRateRequestDto
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyRateRequestDto
     */
    rateToUSD?: string;
    /**
     * 
     * @type {Date}
     * @memberof CurrencyRateRequestDto
     */
    applicableFrom?: Date;
}

/**
 * Check if a given object implements the CurrencyRateRequestDto interface.
 */
export function instanceOfCurrencyRateRequestDto(value: object): value is CurrencyRateRequestDto {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function CurrencyRateRequestDtoFromJSON(json: any): CurrencyRateRequestDto {
    return CurrencyRateRequestDtoFromJSONTyped(json, false);
}

export function CurrencyRateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyRateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'rateToUSD': json['rateToUSD'] == null ? undefined : json['rateToUSD'],
        'applicableFrom': json['applicableFrom'] == null ? undefined : (new Date(json['applicableFrom'])),
    };
}

export function CurrencyRateRequestDtoToJSON(json: any): CurrencyRateRequestDto {
    return CurrencyRateRequestDtoToJSONTyped(json, false);
}

export function CurrencyRateRequestDtoToJSONTyped(value?: CurrencyRateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyCode': value['currencyCode'],
        'rateToUSD': value['rateToUSD'],
        'applicableFrom': value['applicableFrom'] == null ? undefined : ((value['applicableFrom']).toISOString()),
    };
}

